<script>
export default {
    name: "PrintPrescription",

    data() {

        return {
            patient: {},
            prescriptions: [],
            printstamp:this.$root.companyconfigsprintprescriptionstamp,
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatient(), this.fetchPrescriptions(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.params.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchPrescriptions() {

            return this.$http.get(`MedicalFile/GetPatientDrugsandConsumblesTreatment?PatientID=${this.$route.params.patientID}&VisitNo=${this.$route.params.visitNO}`).then(response => {
                this.prescriptions = response.data;
            }).catch(() => {});
        },
         getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
          <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              <div class="md:w-1/3 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: 
                                        <span class="text-blue-700">{{ patient.names }}</span></h5>
                              </div>
                              
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="text-blue-700">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="text-blue-700">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN: 
                                         <span class="text-blue-700">{{ patient.patienT_ID }}</span></h5>
                              </div><div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Age: 
                                         <span class="text-blue-700">{{ patient.age}} Yr(s)</span></h5>
                              </div>
                              
                          </div>
       <h5 class="w-full font-bold text-center">PATIENT PRESCRIPTION</h5>
        <table class="table">
            <thead class="text-xs">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/6">Date</th>
                    <th class="p-tiny w-1/3">Drug</th>
                    <th class="p-tiny w-1/3">Description</th>
                    <th class="p-tiny w-1/6">Requested By</th>
                </tr>
            </thead>
            <tbody class="text-xs flex flex-col">
                <tr class="w-full flex" v-for="(pres, idx) in prescriptions" :key="idx">
                    <td class="p-tiny w-1/6">{{ pres.date | dateFormat }}</td>
                    <td class="p-tiny w-1/3">{{ pres.drug }}</td>
                    <td class="p-tiny w-1/3">{{ pres.description }}</td>
                    <td class="p-tiny w-1/6">{{ pres.requested_By }}</td>
                </tr>
            </tbody>
        </table>
        <div class="w-full flex flex-wrap p-1 my-1 border-t-2 border-gray-800">
            
            <div class="w-full p-1 text-right">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
        </div><div class="w-full text-right mt-35">  <tail-stamp></tail-stamp>
            <!-- <tail-stamp v-if="printstamp"></tail-stamp> -->
       </div> 
    </div>
</template>